import { createTheme, PaletteMode, Theme } from '@mui/material';

import { colors } from './colors';
import { getPalette, GetPaletteOptions } from './palette';
import { fonts, typography } from './typography';

export const createCustomTheme = (
  mode: PaletteMode,
  options?: GetPaletteOptions,
): Theme => {
  return createTheme({
    palette: getPalette(mode, options),
    colors,
    spacing: [0, 4, 8, 16, 32, 40, 48],
    typography: {
      ...typography,
      fontFamily: fonts.default,
    },
    components: {
      MuiPopover: {
        styleOverrides: {
          paper: {
            borderRadius: '16px',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
            marginLeft: 4,
          },
        },
      },
      MuiButton: {
        styleOverrides: {
          root: {
            borderRadius: '100px',
          },
        },
      },
      MuiIconButton: {
        styleOverrides: {
          root: {
            borderRadius: '10em',
          },
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 560,
        md: 992,
        lg: 1280,
        xl: 1440,
        xxl: 1920,
      },
    },
  });
};

export default createCustomTheme;
